<template>
    <div id="EditProducerSetting">
      <EditProducerGeneralSetting :data="is_admin_dealer" />
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import EditProducerGeneralSetting from "../producer/EditProducerGeneralSetting.vue"
  
  
  export default {
    name: "EditProducerSetting",
    created() {
      
    },
    data() {
      return {
        is_admin_dealer:1
      };
    },
    components: {
        EditProducerGeneralSetting
    },
   
    methods: {
     
    },
   
  };
  </script>
  
  <style scoped>
  
  </style>